import PageWrap from "@home/pages/studio/potentialMarket/components/PageWrap";
import SummaryService from "@home/pages/studio/potentialMarket/components/SummaryService";
import TableService from "@home/pages/studio/potentialMarket/components/TableService";
import MobileOverlapService from "@home/pages/studio/potentialMarket/components/MobileOverlapService";

export default {
  PageWrap,
  SummaryService,
  TableService,
  MobileOverlapService,
};
